module.exports = __webpack_public_path__ + "static/img/DrShabnamKarDas.4610bdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/DrShabnamKarDas.png
// module id = jyEF
// module chunks = 1